/* Arian Leather jacket builder. Reads product data from the section's JSON, renders the tinted sketch, prices live, adds to bag. */
(function () {
  'use strict';
  var root = document.querySelector('[data-customizer]');
  var cfgEl = document.querySelector('[data-cz-config]');
  if (!root || !cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var S = cfg.strings;
  var COLOURS = { 'Black': '#1C1B1B', 'Dark brown': '#4A2E1C', 'Cognac': '#9A5A2A', 'Green': '#2F3A2C', 'Oxblood': '#5A1E22' };
  var HARDWARE = { 'Silver': '#C9C9C9', 'Gunmetal': '#5E6168', 'Brass': '#C9A24D' };
  var LININGS = { 'Black quilted': '#2B2B30', 'Red satin': '#7A1E22', 'Tartan flannel': '#5B3A2E' };
  var SIZES = ['S', 'M', 'L', 'XL', 'XXL'];

  var state = { kind: 'jacket', gender: 'men', style: null, leather: 'sheep', colour: 'Black', hardware: 'Silver', lining: 'Black quilted', emb: { back: false, chest: false, arm: false, pocket: false }, size: null, view: 'front', ack: false, notes: '', measures: {} };

  function colourName(c) { return (S.colours && S.colours[c]) || c; }
  function hwName(h) { return (S.hardwareNames && S.hardwareNames[h]) || h; }
  function liName(l) { return (S.liningNames && S.liningNames[l]) || l; }
  function money(cents) {
    var fmt = (cfg.moneyFormat || '€{{amount}}').replace(/<[^>]+>/g, '');
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/); var key = m ? m[1] : 'amount'; var n = cents / 100;
    function num(dec, thou, decs) { var parts = n.toFixed(decs).split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou); return decs ? parts[0] + dec + parts[1] : parts[0]; }
    var s;
    switch (key) {
      case 'amount_no_decimals': s = num('.', ',', 0); break;
      case 'amount_with_comma_separator': s = num(',', '.', 2); break;
      case 'amount_no_decimals_with_comma_separator': s = num(',', '.', 0); break;
      case 'amount_with_space_separator': s = num(',', ' ', 2); break;
      case 'amount_no_decimals_with_space_separator': s = num(',', ' ', 0); break;
      case 'amount_with_apostrophe_separator': s = num('.', "'", 2); break;
      default: s = num('.', ',', 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  function darken(hex) {
    var n = parseInt(hex.slice(1), 16); var f = function (v) { return Math.max(0, Math.round(v * 0.72)).toString(16).padStart(2, '0'); };
    return '#' + f(n >> 16) + f((n >> 8) & 255) + f(n & 255);
  }
  function product() { return cfg.products[state.kind + ':' + state.gender] || null; }
  function optIndex(p, name, fallback) { var i = (p && p.options ? p.options : []).indexOf(name); return i < 0 ? fallback : i; }
  function styles() {
    var p = product(); if (!p) return [];
    var k = 'option' + (optIndex(p, 'Style', 0) + 1); var seen = [];
    (p.variants || []).forEach(function (v) { if (v[k] && seen.indexOf(v[k]) === -1) seen.push(v[k]); });
    return seen;
  }
  function variantFor(style, size) {
    var p = product(); if (!p) return null;
    var ks = 'option' + (optIndex(p, 'Style', 0) + 1), kz = 'option' + (optIndex(p, 'Size', 1) + 1);
    return (p.variants || []).find(function (v) { return v[ks] === style && v[kz] === size; }) || null;
  }
  function addon(key) {
    var title = (cfg.addonTitles || {})[key]; var a = cfg.addons;
    if (!a || !a.variants) return null;
    return a.variants.find(function (v) { return v.title === title || v.option1 === title; }) || null;
  }
  function addonPrice(key) { var v = addon(key); return v ? v.price : 0; }
  function embCount() { return Object.keys(state.emb).filter(function (k) { return state.emb[k]; }).length; }
  function basePrice() {
    var v = variantFor(state.style, state.size === 'custom' ? 'Custom' : (state.size || 'M'));
    if (!v) { var p = product(); v = p && p.variants ? p.variants[0] : null; }
    return v ? v.price : 0;
  }
  function total() {
    var t = basePrice();
    if (state.kind === 'jacket' && state.leather === 'cow') t += addonPrice('cowhide');
    t += embCount() * addonPrice('embroidery');
    if (state.size === 'custom') t += addonPrice('custom');
    return t;
  }

  /* ---------- rendering ---------- */
  function setGroupSelection(group, value) {
    root.querySelectorAll('[data-cz-group="' + group + '"] [data-cz-set]').forEach(function (b) {
      var on = b.getAttribute('data-cz-value') === String(value);
      if (b.classList.contains('al-swatch')) b.classList.toggle('al-swatch--on', on);
      else if (b.classList.contains('al-pill')) b.classList.toggle('al-pill--on', on);
      else b.classList.toggle('al-opt--on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function out(key, text) { root.querySelectorAll('[data-cz-out="' + key + '"]').forEach(function (el) { el.textContent = text; }); }
  function renderStyles() {
    var wrap = root.querySelector('[data-cz-styles]'); var list = styles();
    if (list.indexOf(state.style) === -1) state.style = list[0] || null;
    wrap.innerHTML = '';
    list.forEach(function (name) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'al-opt'; b.setAttribute('data-cz-set', 'style'); b.setAttribute('data-cz-value', name);
      b.innerHTML = '<span class="al-opt__n">' + name + '</span>';
      b.addEventListener('click', function () { state.style = name; if (name === 'Trucker') state.emb.chest = false; render(); });
      wrap.appendChild(b);
    });
  }
  function renderSizes() {
    var wrap = root.querySelector('[data-cz-sizes]'); wrap.innerHTML = '';
    SIZES.concat(['custom']).forEach(function (size) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'al-pill'; b.setAttribute('data-cz-set', 'size'); b.setAttribute('data-cz-value', size);
      b.textContent = size === 'custom' ? S.custom + ' · +' + money(addonPrice('custom')) : size;
      var v = variantFor(state.style, size === 'custom' ? 'Custom' : size);
      if (!v || !v.available) { b.classList.add('al-pill--muted'); b.title = S.unavailable_style; }
      b.addEventListener('click', function () { state.size = size; render(); });
      wrap.appendChild(b);
    });
  }
  var SKETCH = { 'Phantom': 'phantom', 'Thunder Ride': 'thunder-ride', 'Pilot': 'pilot', 'Trucker': 'trucker', 'Stripes': 'stripes', 'Urban': 'urban', 'Aviator': 'aviator', 'Urban Edge': 'urban-edge', 'Rebel': 'rebel', 'SOA': 'soa', 'Classic': 'classic-m' };
  var SKETCH_W = { 'Phantom': 'phantom-w', 'Thunder Ride': 'thunder-ride-w', 'Pilot': 'pilot-w', 'Trucker': 'trucker-w', 'Stripes': 'stripes-w', 'Urban': 'urban-w', 'Aviator': 'aviator-w', 'Classic': 'classic-w' };
  /* embroidery zones as [left, top, width, height] in % of the figure box */
  var ZONES = {
    jacket: { front: { chest: [57, 27, 14, 12], arm: [8, 31, 13, 18] }, back: { back: [36, 24, 28, 34] } },
    vest: { front: { chest: [57, 24, 14, 12] }, back: { back: [36, 22, 28, 36] } }
  };
  /* the drawing is one file per style and view: alpha = garment silhouette (tint mask), RGB = ink lines (luminance mask) */
  var loaded = {}; var pending = null;
  function preload(url, cb) {
    if (!url) return; if (loaded[url]) { if (cb) cb(); return; }
    var im = new Image(); im.onload = function () { loaded[url] = true; if (cb) cb(); }; im.src = url;
  }
  function showSketch(fig, url, inkUrl) {
    pending = url;
    preload(url, function () { preload(inkUrl, function () {
      if (pending !== url) return;
      fig.style.setProperty('--cz-mask', 'url("' + url + '")');
      fig.style.setProperty('--cz-ink-mask', 'url("' + (inkUrl || url) + '")');
      fig.classList.add('al-cz__fig--ready');
    }); });
  }
  function luminance(hex) { var n = parseInt(hex.slice(1), 16); return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255; }
  function sketchName() {
    var base = (state.gender === 'women' && SKETCH_W[state.style]) || SKETCH[state.style] || (state.kind === 'vest' ? 'soa' : 'phantom');
    var name = base + '-' + state.view;
    if (!(cfg.sketches || {})[name]) name = base + '-front';
    return name;
  }
  function renderDrawing() {
    var leather = COLOURS[state.colour] || '#1C1B1B';
    var fig = root.querySelector('[data-cz-fig]');
    if (fig) {
      var url = (cfg.sketches || {})[sketchName()] || ''; var inkUrl = (cfg.sketches || {})[sketchName() + '-ink'] || '';
      fig.style.setProperty('--cz-leather', leather);
      fig.style.setProperty('--cz-ink', luminance(leather) > 0.28 ? '#2A2826' : '#D6D0C6');
      showSketch(fig, url, inkUrl);
      fig.setAttribute('aria-label', state.view === 'back' ? (S.preview_back_alt || '') : (S.preview_alt || ''));
      var otherName = sketchName().replace(/-(front|back)$/, state.view === 'front' ? '-back' : '-front'); preload((cfg.sketches || {})[otherName]); preload((cfg.sketches || {})[otherName + '-ink']);
      var zones = (ZONES[state.kind] || ZONES.jacket)[state.view] || {};
      root.querySelectorAll('[data-cz-zone]').forEach(function (z) {
        var k = z.getAttribute('data-cz-zone'); var box = zones[k];
        var on = !!box && !!state.emb[k] && (k !== 'arm' || state.kind === 'jacket') && (k !== 'chest' || (state.kind === 'jacket' && state.style !== 'Trucker'));
        z.hidden = !on;
        if (box) { z.style.left = box[0] + '%'; z.style.top = box[1] + '%'; z.style.width = box[2] + '%'; z.style.height = box[3] + '%'; }
      });
    }
    var dots = { leather: leather, hardware: HARDWARE[state.hardware] || '#C9C9C9', lining: LININGS[state.lining] || '#2B2B30' };
    root.querySelectorAll('[data-cz-dot]').forEach(function (d) { d.style.background = dots[d.getAttribute('data-cz-dot')]; });
    root.querySelectorAll('[data-cz-view]').forEach(function (b) { b.classList.toggle('al-on', b.getAttribute('data-cz-view') === state.view); });
  }
  function embList() {
    var names = { back: S.emb_back, chest: S.emb_chest, arm: S.emb_arm, pocket: S.emb_pocket };
    return Object.keys(state.emb).filter(function (k) { return state.emb[k]; }).map(function (k) { return names[k]; });
  }
  function render() {
    root.querySelectorAll('[data-cz-only]').forEach(function (el) { el.toggleAttribute('hidden', el.getAttribute('data-cz-only') !== state.kind); });
    if (state.kind === 'vest') { state.emb.arm = false; state.leather = 'cow'; }
    else if (state.leather !== 'cow') state.leather = 'sheep';
    if (state.kind === 'jacket' && state.style === 'Trucker') { state.emb.chest = false; }
    var chestNote = root.querySelector('[data-cz-chest-note]'); if (chestNote) chestNote.hidden = state.style !== 'Trucker';
    var chestBox = root.querySelector('[data-cz-emb="chest"]'); if (chestBox) chestBox.disabled = state.style === 'Trucker';
    renderStyles();
    renderSizes();
    setGroupSelection('kind', state.kind); setGroupSelection('gender', state.gender); setGroupSelection('style', state.style);
    setGroupSelection('leather', state.leather); setGroupSelection('colour', state.colour); setGroupSelection('hardware', state.hardware);
    setGroupSelection('lining', state.lining); setGroupSelection('size', state.size);
    root.querySelectorAll('[data-cz-emb]').forEach(function (cb) { cb.checked = !!state.emb[cb.getAttribute('data-cz-emb')]; cb.nextElementSibling.classList.toggle('al-check__box--on', cb.checked); });
    var ackBox = root.querySelector('[data-cz-ack]'); if (ackBox) { ackBox.checked = state.ack; ackBox.nextElementSibling.classList.toggle('al-check__box--on', state.ack); }
    var m = root.querySelector('[data-cz-measurements]'); if (m) m.hidden = state.size !== 'custom';
    renderDrawing();
    var leatherName = state.kind === 'vest' ? S.cow : (state.leather === 'cow' ? S.cow : S.sheep);
    var sizeName = state.size === 'custom' ? S.custom : (state.size || '—');
    out('piece', S[state.kind] + ' · ' + S[state.gender]);
    out('style', state.style || '—'); out('leather', leatherName); out('colour', colourName(state.colour)); out('hardware', hwName(state.hardware)); out('lining', liName(state.lining));
    out('embroidery', embCount() + ' ' + S.placements + ' · ' + money(addonPrice('embroidery')) + ' ' + S.each);
    out('cowhide_price', S.cowhide_desc.replace('{price}', money(addonPrice('cowhide'))));
    var t = total(); out('price', money(t)); out('price2', money(t));
    root.querySelector('[data-cz-title]').textContent = (state.style || '') + ' · ' + colourName(state.colour);
    root.querySelector('[data-cz-subtitle]').textContent = hwName(state.hardware) + ' · ' + liName(state.lining);
    var sum = root.querySelector('[data-cz-summary]');
    sum.innerHTML = [[S.piece, S[state.kind] + ' · ' + S[state.gender]], [S.style, state.style || '—'], [S.leather, leatherName + ' · ' + colourName(state.colour)], [S.hardware, hwName(state.hardware)], [S.lining, liName(state.lining)], [S.embroidery, embList().join(', ') || S.none], [S.size, sizeName]]
      .map(function (r) { return '<span>' + r[0] + '</span><span>' + r[1] + '</span>'; }).join('');
    var err = root.querySelector('[data-cz-error]'); if (err && !err.hidden && state.ack && state.size) err.hidden = true;
  }

  /* ---------- events ---------- */
  root.querySelectorAll('[data-cz-set]').forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.getAttribute('data-cz-set'); var val = b.getAttribute('data-cz-value');
      if (key === 'kind' || key === 'gender') { state[key] = val; state.style = null; state.size = null; }
      else state[key] = val;
      render();
    });
  });
  root.querySelectorAll('[data-cz-emb]').forEach(function (cb) { cb.addEventListener('change', function () { state.emb[cb.getAttribute('data-cz-emb')] = cb.checked; render(); }); });
  var ack = root.querySelector('[data-cz-ack]'); if (ack) ack.addEventListener('change', function () { state.ack = ack.checked; render(); });
  root.querySelectorAll('[data-cz-view]').forEach(function (b) { b.addEventListener('click', function () { state.view = b.getAttribute('data-cz-view'); renderDrawing(); }); });
  var notes = root.querySelector('[data-cz-notes]'); if (notes) notes.addEventListener('input', function () { state.notes = notes.value; });
  root.querySelectorAll('[data-cz-measure]').forEach(function (i) { i.addEventListener('input', function () { state.measures[i.getAttribute('data-cz-measure')] = i.value; }); });

  /* share: encode the design in the URL hash */
  function encode() { var copy = JSON.parse(JSON.stringify(state)); delete copy.notes; delete copy.measures; delete copy.ack; return btoa(unescape(encodeURIComponent(JSON.stringify(copy)))); }
  function decode(h) { try { return JSON.parse(decodeURIComponent(escape(atob(h)))); } catch (e) { return null; } }
  var share = root.querySelector('[data-cz-share]');
  if (share) share.addEventListener('click', function () {
    var url = window.location.origin + window.location.pathname + '#d=' + encode();
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { share.textContent = S.copied; setTimeout(function () { share.textContent = share.getAttribute('data-label') || share.textContent; }, 2000); });
    if (window.history && window.history.replaceState) window.history.replaceState({}, '', '#d=' + encode());
  });
  if (share) share.setAttribute('data-label', share.textContent);
  var hash = window.location.hash;
  if (hash.indexOf('#d=') === 0) { var saved = decode(hash.slice(3)); if (saved) Object.keys(saved).forEach(function (k) { state[k] = saved[k]; }); }
  var qs = new URLSearchParams(window.location.search);
  if (qs.get('style')) state.style = qs.get('style');
  if (qs.get('kind')) state.kind = qs.get('kind');
  if (qs.get('for')) state.gender = qs.get('for');

  /* add to bag: main variant with properties (and the artwork file), then the add-ons */
  var form = root.querySelector('[data-cz-form]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var err = root.querySelector('[data-cz-error]'); var btn = root.querySelector('[data-cz-submit]');
    function fail(msg) { err.textContent = msg; err.hidden = false; btn.disabled = false; err.scrollIntoView({ block: 'nearest' }); }
    if (!state.size) return fail(S.size_required);
    if (state.size === 'custom' && ['chest', 'waist', 'shoulder', 'sleeve', 'back'].some(function (k) { return !state.measures[k]; })) return fail(S.measure_required);
    if (!state.ack) return fail(S.ack_required);
    var variant = variantFor(state.style, state.size === 'custom' ? 'Custom' : state.size);
    if (!variant || !variant.available) return fail(S.unavailable_style);
    btn.disabled = true; err.hidden = true;
    var designId = 'AL-' + Date.now().toString(36).toUpperCase();
    var fd = new FormData();
    fd.append('id', variant.id); fd.append('quantity', '1');
    var props = {
      'Piece': S[state.kind] + ' · ' + S[state.gender], 'Style': state.style,
      'Leather': state.kind === 'vest' ? S.cow : (state.leather === 'cow' ? S.cow : S.sheep), 'Colour': state.colour,
      'Hardware': state.hardware, 'Lining': state.lining, 'Embroidery': embList().join(', ') || S.none,
      'Size': state.size === 'custom' ? S.custom : state.size, 'Withdrawal acknowledged': 'Yes', 'Design ID': designId
    };
    if (state.notes) props['Embroidery notes'] = state.notes.slice(0, 2000);
    if (state.size === 'custom') Object.keys(state.measures).forEach(function (k) { if (state.measures[k]) props['Measure ' + k + ' (cm)'] = state.measures[k]; });
    Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
    var fileInput = root.querySelector('[data-cz-artwork]');
    if (fileInput && fileInput.files && fileInput.files[0]) fd.append('properties[Artwork]', fileInput.files[0]);

    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to bag.');
        var items = [];
        var tag = { 'For design': designId, 'Piece': state.style + ' · ' + state.colour };
        if (state.kind === 'jacket' && state.leather === 'cow' && addon('cowhide')) items.push({ id: addon('cowhide').id, quantity: 1, properties: tag });
        if (embCount() > 0 && addon('embroidery')) items.push({ id: addon('embroidery').id, quantity: embCount(), properties: Object.assign({ 'Placements': embList().join(', ') }, tag) });
        if (state.size === 'custom' && addon('custom')) items.push({ id: addon('custom').id, quantity: 1, properties: tag });
        if (!items.length) return;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('Options could not be added.'); });
      })
      .then(function () { btn.disabled = false; document.dispatchEvent(new CustomEvent('al:cart:added')); })
      .catch(function (ex) { fail(ex.message); });
  });

  render();
  setTimeout(function () { var vest = /^(soa|classic)/; Object.keys(cfg.sketches || {}).forEach(function (k) { if (vest.test(k) === (state.kind === 'vest')) preload(cfg.sketches[k]); }); }, 2500);
})();
